import { AU_BOUND } from '@types';
import { useState } from 'react';

type TCoordinates = {
	lat: number;
	lng: number;
}

type TBounds = {
	east: number;
	west: number;
	north: number;
	south: number;
}

export const useGetMapBounds = (defaultToAU: boolean = true) => {
	const [bounds, setBounds] = useState<TBounds | null>(defaultToAU ? AU_BOUND : null);

	const isWithinAU = (lat: number, lng: number) => {
		return lat > -43.00311 && lat < -12.46113 && lng > 113.6594 && lng < 153.61194;
	};

	const getBounds = (coordinates: TCoordinates[]) => {
		let internalBounds: TBounds | null = null;
		if (coordinates.length) {
			coordinates.forEach((coord) => {
				if (isWithinAU(coord.lat, coord.lng)) {
					if (!internalBounds) {
						const newBounds = {
							east: coord.lng || AU_BOUND.east,
							west: coord.lng || AU_BOUND.west,
							north: coord.lat || AU_BOUND.north,
							south: coord.lat || AU_BOUND.south
						}
						internalBounds = newBounds;
						setBounds(newBounds);
					} else {
						if (internalBounds.west > coord.lng) {
							internalBounds.west = coord.lng;
						} else if (internalBounds.east < coord.lng) {
							internalBounds.east = coord.lng;
						}

						if (internalBounds.south > coord.lat) {
							internalBounds.south = coord.lat;
						} else if (internalBounds.north < coord.lat) {
							internalBounds.north = coord.lat;
						}
					}
				}
			});
		}
		setBounds(internalBounds);
	}

	return {
		bounds,
		getBounds
	}
}
